import React from 'react'
import styled from 'styled-components'

const AddressContainer = styled.div`
  display: table;
  table-layout: fixed;
  width: 100%;
  white-space: nowrap;
`

const EllipsisBox = styled.div`
  max-width: 100%;
  display: inline-flex;
  flex-wrap: nowrap;
`

const EllipsisBoxStart = styled.div`
  flex: 0 1 auto;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`

const EllipsisBoxEnd = styled.div`
  flex: 1 0 auto;
  white-space: nowrap;
  margin-left: -1px;
`

export default function TruncateAddress({ children, address }) {
  const childrenStart = children.substring(0, 36)
  const childrenEnd = children.substring(36, 43)
  return (
    <span>
      {address ? (
        <AddressContainer>
          <EllipsisBox>
            <EllipsisBoxStart>{childrenStart}</EllipsisBoxStart>
            <EllipsisBoxEnd>{childrenEnd}</EllipsisBoxEnd>
          </EllipsisBox>
        </AddressContainer>
      ) : (
        <EllipsisBox>
          <EllipsisBoxStart>{childrenStart}</EllipsisBoxStart>
          <EllipsisBoxEnd>{childrenEnd}</EllipsisBoxEnd>
        </EllipsisBox>
      )}
    </span>
  )
}
